<template>
  <ElDropdown trigger="click" @command="emitCommand">
    <ElButton
      size="mini"
      native-type="button"
      type="primary"
      icon="el-icon-plus"
    >
      {{ $t('ADVERTISEMENT.ADD_BID') }}
    </ElButton>
    <ElDropdownMenu slot="dropdown">
      <ElDropdownItem :command="dropDownCommands.ADD_SINGLE_BID">
        {{ $t('ADVERTISEMENT.ADD_SINGLE_BID') }}
      </ElDropdownItem>
      <ElDropdownItem :command="dropDownCommands.ADD_BULK_BID" divided>
        {{ $t('ADVERTISEMENT.ADD_BULK_BID') }}
      </ElDropdownItem>
    </ElDropdownMenu>
  </ElDropdown>
</template>

<script>
import { dropDownCommands } from './common/constant';

export default {
  name: 'AddBidDropdown',
  computed: {
    dropDownCommands() {
      return dropDownCommands;
    },
  },
  methods: {
    emitCommand(cmd) {
      this.$emit('command', cmd);
    },
  },
};
</script>
